module.exports = __webpack_public_path__ + "media/images/your_approachto_mindsetting-93b910202dcb5e16c488c9d0232a425b.png";